const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.PUBLIC, ApiDataModel.CART_BLOCKED_DATES)

export const apiCartBlockedDates = {
	fetchCartBlockedDates: async (dietID: number) => {
		const { data } = await apiCommon<ICartBlockedDates>(`${groupPrefix}/${dietID}`, {
			method: 'GET',
		})
		return { data: CartBlockedDates(data) }
	},
}
